import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=4550dd4d&scoped=true"
import script from "./Voucher.vue?vue&type=script&lang=js"
export * from "./Voucher.vue?vue&type=script&lang=js"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=4550dd4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4550dd4d",
  null
  
)

export default component.exports